var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTollRoad02 = function SvgTollRoad02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "toll-road-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#toll-road-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.999 12a11.99 11.99 0 0 1-5.984 10.384l-.022.013A11.922 11.922 0 0 1 12 24a11.893 11.893 0 0 1-5.972-1.591l-.021-.012A11.994 11.994 0 0 1 0 11.999C0 7.556 2.415 3.675 6.005 1.603l.021-.012A11.934 11.934 0 0 1 12 0a11.964 11.964 0 0 1 6.017 1.616A11.992 11.992 0 0 1 24 12h-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.009 5.964v5.607H15.25v-.832H8.773v.832H6.009V5.964a8.483 8.483 0 0 1 6-2.475c2.34 0 4.461.946 6 2.475Zm-.01 12.08v-4.385H6v4.366a8.483 8.483 0 0 0 6.01 2.484 8.483 8.483 0 0 0 5.99-2.465Zm-3.358-5.873v-.832H9.363v.832h-5.56v.888h.41v2.12h.713v-2.12h14.147v2.12h.713v-2.12h.409v-.888H14.64Zm-4.334.324a.385.385 0 1 1 .001-.769.385.385 0 0 1 0 .769Zm1.695 0a.385.385 0 1 1-.002-.77.385.385 0 0 1 .002.77Zm1.693 0a.385.385 0 1 1 .001-.77.385.385 0 0 1-.001.77Zm-4.196-5.61V4.915h5v1.968h-5Zm0 3.127V8.044h5v1.968h-5Zm0 4.29v1.968h5v-1.968h-5Zm0 5.098v-1.968h5V19.4h-5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "toll-road-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgTollRoad02 as ReactComponent };